export enum ERoles {
    User = 'USER',
    Technician = 'TECHNICIAN',
    Service = 'SERVICE',
    Subsidiary = 'SUBSIDIARY',
    Admin = 'ADMIN',
    Marketing = 'MARKETING'
}

export interface Role {
    Id: number;
    Description: string;
}

export interface RoleExplained {
    isUser?: boolean;
    isTechnician?: boolean;
    isService?: boolean;
    isAdmin?: boolean;
    isMarketing?: boolean;
    isSubsidiary?: boolean;
}
